var _excluded = ["direction", "media"];

var _jsxFileName = "/Users/krise/gitlab/drywall/src/components/MediaObject/MediaObject.jsx",
    _this = this;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { logDeprecation } from '../../js/util/logging'; // This wrapper is used for nothing other than filtering props that are passed to it so they don't
// bleed through to the DOM
// (styled-components does not filter props when wrapping a third-party component).

var StyledMediaObject = styled.div.withConfig({
  displayName: "MediaObject__StyledMediaObject",
  componentId: "sc-12gs3hz-0"
})([""]);
/**
 * A layout utility for aligning a media figure next to content.
 *
 * ##### Inspiration
 * * https://getbootstrap.com/docs/4.0/layout/media-object/
 * * https://lightningdesignsystem.com/utilities/media-objects/
 * * https://philipwalton.github.io/solved-by-flexbox/demos/media-object/
 * * http://www.stubbornella.org/content/2010/06/25/the-media-object-saves-hundreds-of-lines-of-code
 */

var MediaObject = styled(function (props) {
  var align = props.align,
      renderLayout = props.renderLayout;

  if (align === 'top' || align === 'bottom') {
    logDeprecation('drywall prop `align` for the `MediaObject` component will no longer accept values `top` or `bottom` in the next MAJOR release, use `start` or `end` instead');
  }

  var content = renderLayout;

  if (typeof renderLayout === 'function') {
    content = renderLayout(props);
  } // Remove props that bleed through to the DOM


  var direction = props.direction,
      media = props.media,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(StyledMediaObject, _extends({}, rest, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 12
    }
  }), content);
}).withConfig({
  displayName: "MediaObject",
  componentId: "sc-12gs3hz-1"
})([""]);
MediaObject.Body = styled.div.withConfig({
  displayName: "MediaObject__Body",
  componentId: "sc-12gs3hz-2"
})([""]);
MediaObject.Media = styled.div.withConfig({
  displayName: "MediaObject__Media",
  componentId: "sc-12gs3hz-3"
})([""]);
MediaObject.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * How to align the media content with respect to the children content.
   */
  align: PropTypes.oneOf(['start', 'top', 'center', 'bottom', 'end']),

  /**
   * The body content.
   */
  children: PropTypes.node,

  /**
   * The direction in which the media and content will be placed.
   */
  direction: PropTypes.oneOf(['row', 'column']),

  /**
   * The spacing between media and children content.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  gutter: PropTypes.any,

  /**
   * The media content.
   */
  media: PropTypes.node,

  /**
   * You can use `renderLayout` to modify the default composition of the component.
   * Pass your own node using the `<MediaObject.Body>` and `<MediaObject.Media>` wrappers,
   * or pass a render function that receives enhanced props as the only argument.
   */
  renderLayout: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /**
   * By default, the media will come before the body.
   * Set this to reverse the order of media and body.
   */
  reverse: PropTypes.bool
} : {};
MediaObject.defaultProps = {
  align: 'start',
  direction: 'row',
  // eslint-disable-next-line zillow/react/prop-types
  renderLayout: function renderLayout(_ref) {
    var media = _ref.media,
        children = _ref.children;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 82,
        columnNumber: 9
      }
    }, media && /*#__PURE__*/React.createElement(MediaObject.Media, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 83,
        columnNumber: 23
      }
    }, media), children && /*#__PURE__*/React.createElement(MediaObject.Body, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 84,
        columnNumber: 26
      }
    }, children));
  },
  reverse: false
};
/** @component */

export default MediaObject;